/*
 * @Descripttion:
 * @version:
 * @Author: Mark
 * @Date: 2020-05-23 11:49:25
 * @LastEditors: dandan.Wu
 * @LastEditTime: 2021-03-29 18:31:54
 */

export const uploadFrom: UploadVideoAPI.UploadFrom = {
         video: {
           vrsId: 0,
           finsh: false,
           percent: 0,
           speed: '',
           uploadlog: '',
           status: 0,
           fileCloudId: '',
           fileName: '',
         },
         tagCategory: '',
         story: '',
         classId: '',
         actid: '',
         planid: '',
         typearea: [],
         areaid: 0,
         userclassTag: '',
         userstarTag: '',
         userclipTag: '',
       }

export const uploadChannel: UploadVideoAPI.Channel[] = [
  { text: '综艺', id: '1', disabled: false },
  { text: '电视剧', id: '2', disabled: false },
  { text: '电影', id: '3', disabled: false },
  { text: '动漫', id: '50', disabled: false },
  { text: '娱乐', id: '120', disabled: false },
  { text: '新闻', id: '106', disabled: false },
  { text: '纪录片', id: '51', disabled: false },
  { text: '音乐', id: '20', disabled: false },
  { text: '原创', id: '111', disabled: false },
  { text: '生活', id: '105', disabled: false },
  { text: '教育', id: '115', disabled: false },
  { text: '游戏', id: '116', disabled: false },
]
